module.exports = __webpack_public_path__ + "images/signal_2.ab51fd54b370252026f45a090f06bd8b.png";